import React from 'react';
import { ReportSectionAttributePair } from '@/types';

interface ComponentAttributesProps {
  pairs: ReportSectionAttributePair[];
}

const ComponentAttributes: React.FC<ComponentAttributesProps> = ({ pairs }) => {
  if (pairs.length === 0) return null;

  return (
    <dl
      className="grid gap-x-6 gap-y-1 text-sm"
      style={{ gridTemplateColumns: 'max-content 1fr' }}
    >
      {pairs.map((p, i) => (
        <React.Fragment key={i}>
          <dt className="text-gray-500 font-medium">{p.label}</dt>
          <dd className="text-gray-900 m-0">{p.value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
};

export default ComponentAttributes;
